module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/pod.ba954328.svg";